import { isUndefined, isNull } from 'lodash';

const map = {
  init() {
    const $container = document.getElementById('map');

    if (isUndefined($container) || isNull($container)) {
      return false;
    }

    const coords = new window.kakao.maps.LatLng(
      37.519489568865,
      127.026639983471
    );
    const mapOption = {
      center: coords,
      draggable: false,
      level: 3,
    };

    const map = new window.kakao.maps.Map($container, mapOption);
    const geocoder = new window.kakao.maps.services.Geocoder();

    geocoder.addressSearch('서울 강남구 도산대로 165', function(
      result,
      status
    ) {
      if (status === window.kakao.maps.services.Status.OK) {
        console.log(result[0].y, result[0].x);
        const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
        const content =
          '<div class="map-overlay"><a href="" target="_blank"><div class="map-overlay__logo"></div><span class="map-overlay__triangle"></span></a></div>';

        const customOverlay = new window.kakao.maps.CustomOverlay({
          position: coords,
          content: content,
          yAnchor: 1.2,
          xAnchor: 0.5,
        });

        customOverlay.setMap(map);
        map.setCenter(coords);

        window.addEventListener('resize', function() {
          map.setCenter(coords);
        });
      }
    });
  },
};

export default map;



// WEBPACK FOOTER //
// ./scripts/map.js